import { useSynqoHttpConfig } from '@Hooks/useSynqoHttpConfig';
import { SynqoHttpConfigProvider } from '@synqo/frontend-component-library';
import { type FC, type PropsWithChildren } from 'react';

export const SynqoCloudHttpConfigProvider: FC<PropsWithChildren> = ({ children }) => {
    const httpConfig = useSynqoHttpConfig();

    return <SynqoHttpConfigProvider synqoHttpConfig={httpConfig}>{children}</SynqoHttpConfigProvider>;
};
